import { createAction } from '@reduxjs/toolkit';

/**
 * Which investor the Apex or Plaid wealth data in the store was loaded for,
 * when, and for which chart range. Wealth reuses that data when the investor
 * comes back within a few minutes instead of clearing and reloading it.
 */
export type WealthDataCache = {
  userId: string | null;
  loadedAt: number | null;
  range: string | null;
};

export const WEALTH_DATA_REUSE_MS = 5 * 60 * 1000;

export const emptyWealthDataCache = (): WealthDataCache => ({
  userId: null,
  loadedAt: null,
  range: null,
});

/** Forget loaded wealth data, e.g. after a deposit or a new linked account. */
export const invalidateWealthData = createAction('wealthData/invalidate');

// Wealth opens on the ALL range, so only data loaded for ALL can be reused.
export const isWealthDataReusable = (
  cache: WealthDataCache | undefined,
  userId: string | null,
  now: number = Date.now(),
): boolean =>
  Boolean(userId) &&
  cache !== undefined &&
  cache.userId === userId &&
  cache.loadedAt !== null &&
  now - cache.loadedAt < WEALTH_DATA_REUSE_MS &&
  cache.range === 'ALL';
